"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
require("./weatherModal.scss");
var WeatherAt_1 = require("./WeatherAt");
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('modalWeatherInfo', 'setModalWeatherInfo', {}), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.setModalWeatherInfo(this.props.weatherInfo);
    }
}), recompose_1.pure);
exports.default = enhance(function (props) {
    return (React.createElement(sok_ui_1.Modal, { isOpen: props.show, className: 'diary-entries-modal diary-edit-weather-modal' },
        React.createElement(sok_ui_1.Header, { onClose: function () {
                props.closeModal();
            } }, props.modalType === 'CLOCK7'
            ? (0, translation_1.getLocalization)('diaryEntryView/weather/clockseven')
            : (0, translation_1.getLocalization)('diaryEntryView/weather/clocktwelve')),
        React.createElement("form", { onSubmit: function () {
                props.setWeatherInfo(props.modalWeatherInfo);
                props.closeModal();
            } },
            React.createElement(sok_ui_1.Container, null,
                React.createElement("div", { className: 'modal-content' }, props.modalType === 'CLOCK7' ? (React.createElement(WeatherAt_1.WeatherAt7, { isEditable: true, isDisabled: props.isDisabled, weatherInfo: props.modalWeatherInfo, setWeatherInfo: function (value) {
                        props.setModalWeatherInfo(value);
                    }, weatherCondition: props.weatherCondition })) : (React.createElement(WeatherAt_1.WeatherAt12, { isEditable: true, isDisabled: props.isDisabled, weatherInfo: props.modalWeatherInfo, setWeatherInfo: function (value) {
                        props.setModalWeatherInfo(value);
                    }, weatherCondition: props.weatherCondition })))),
            React.createElement(sok_ui_1.Footer, null,
                React.createElement("div", { className: "modal-buttons" },
                    React.createElement(sok_ui_1.Button, { className: "edit-weather-button", size: "medium", color: "green", text: (0, translation_1.getLocalization)('diaryEntryView/modal/update'), disabled: props.isDisabled, onClick: function () {
                            props.setWeatherInfo(props.modalWeatherInfo);
                            props.closeModal();
                        } }),
                    React.createElement(sok_ui_1.Button, { className: "edit-weather-cancel-button", size: "medium", color: "dark-gray", text: (0, translation_1.getLocalization)('diaryEntryView/modal/cancel'), onClick: function () {
                            props.closeModal();
                        } }))))));
});
